// retrieve index of all validation rules
import { useCallback, useMemo } from 'react';

export const getValidationIndexMapping = (validation?: { type: string; message: string }[]) =>
  validation?.reduce(
    (obj: Record<string, number>, rule: { type: string; message: string }, idx: number) => {
      return { ...obj, [rule.type]: idx };
    },
    {},
  ) || {};

const onSetAtomicProps = ({
  value,
  validationKey,
  validation,
  validationIndexMapping,
  setProps,
}: {
  value: string;
  validationKey: string;
  validation?: { type: string; message: string }[];
  validationIndexMapping: Record<string, number>;
  setProps: (props: Record<string, any>) => void;
}) => {
  const newValidation = [...(validation || [])];

  if (
    typeof validation !== 'undefined' &&
    validation.length > 0 &&
    typeof validationIndexMapping[validationKey] !== 'undefined'
  ) {
    newValidation.splice(validationIndexMapping[validationKey], 1);
  }

  newValidation.push({
    type: validationKey,
    message: value,
  });

  setProps({ validation: newValidation });
};

export const useManageFormFieldValidation = ({
  setProps,
  validation,
}: {
  setProps: (props: Record<string, any>) => void;
  validation?: { type: string; message: string }[];
}) => {
  const validationIndexMapping = useMemo(() => getValidationIndexMapping(validation), [validation]);

  const isRequired = !!validation?.[validationIndexMapping.required];

  const hasEmailValidation = !!validation?.[validationIndexMapping.email];

  const onSetAtomicValidationProps = useCallback(
    (value: string, validationKey: string) =>
      onSetAtomicProps({
        value,
        validationKey,
        validation,
        validationIndexMapping,
        setProps,
      }),
    [validation, setProps, validationIndexMapping],
  );

  return {
    validationIndexMapping,
    isRequired,
    hasEmailValidation,
    onSetAtomicValidationProps,
  };
};
